import { createContext } from "react";

const searchDocContext = createContext()


export default searchDocContext